import cloneDeep from "lodash.clonedeep";
import { VISIBILITY_MODES } from "./model-state";

class CanvasManager {
  constructor() {
    this.canvases = new Map();
  }

  add(id, canvas, scene, camera, renderer, controls, overlayScene, overlayCamera) {
    this.canvases.set(id, {
      canvas,
      scene,
      camera,
      renderer,
      controls,
      id,
      overlayScene,
      overlayCamera,
      hiddenModels: {
        gums: false,
        teeth: false,
        attachments: false,
        superImposition: true,
      },
      visibilityMode: VISIBILITY_MODES.UPPER_LOWER,
      models: {},
      modelGeometries: {},
      superImpositions: {},
      activeMaxilOrMandView: "",
    });

    if (controls) {
      controls.addEventListener("change", () => {
        const zoom = camera.zoom;
        this.canvases.forEach((data, canvasId) => {
          if (canvasId !== id) {
            data.camera.zoom = zoom;
            data.camera.updateProjectionMatrix();
          }
        });
      });
    }

    return this.canvases.get(id);
  }

  update(
    id,
    {
      models,
      hiddenModels,
      visibilityMode,
      modelGeometries,
      superImpositions,
      activeMaxilOrMandView,
      realMaxUpperIndex,
      realMaxLowerIndex,
    }
  ) {
    const values = {};
    // if (models) values.models = JSON.parse(JSON.stringify({ ...models }));
    if (models) values.models = models;
    if (hiddenModels) values.hiddenModels = { ...hiddenModels };
    if (visibilityMode) values.visibilityMode = visibilityMode;
    if (modelGeometries) values.modelGeometries = modelGeometries;
    if (superImpositions) values.superImpositions = superImpositions;
    if (activeMaxilOrMandView || activeMaxilOrMandView === "")
      values.activeMaxilOrMandView = activeMaxilOrMandView;
    if (realMaxUpperIndex != null) values.realMaxUpperIndex = realMaxUpperIndex;
    if (realMaxLowerIndex != null) values.realMaxLowerIndex = realMaxLowerIndex;
    this.canvases.set(id, { ...this.get(id), ...values });
  }

  get(id) {
    return this.canvases.get(id);
  }

  remove(id) {
    const data = this.canvases.get(id);
    if (data) {
      data.renderer.dispose();
      this.canvases.delete(id);
    }
  }

  getAll() {
    return Array.from(this.canvases.values());
  }

  forEach(callback) {
    this.canvases.forEach(callback);
  }
}

window.canvasManager = new CanvasManager();

export default window.canvasManager;
